module.exports = __webpack_public_path__ + "img/balance-chart.97210116.svg";